import {
  Box,
  Button,
  Center,
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  FormControl,
  FormLabel,
  HStack,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppDrawer from "../../../../../components/drawer";
import AppGrid from "../../../../../components/grid";
import AppSkeleton from "../../../../../components/skeleton";
import NavigationTabs from "../../../../../components/tab";
import { chartdata } from "../../../../../utils/data/chartTestData";
import ChartProp from "../../../../../utils/types/prop.chart";
import CreateChart from "../createChart";
import useQualityimprovementTabs from "../../../../../utils/data/QiTabs";
import { color } from "../../../../../utils/theme";
import Title from "../../../../../components/Title";
import AppAlertOne from "../../../../../components/alert/type1";
import {
  getDataEntryProjects,
  getMeasurementResults,
  getRunChartInterpretation,
  interpretationDescription,
} from "../../../DataEntry/dataEntryService";
import { ProjectType } from "../../../../../utils/types/cycle";
import { Option } from "../../../../../utils/types/props.dropdown";
import Select from "react-select";
import RunChart, { RunChartDataType } from "../../../../../components/runchart";
import { getUpperAndLowerLimit } from "./chartService";
import AppChart from "../../../../../components/chart";

const ChartDashboard = () => {
  const [allProjects, setAllProjects] = useState<Option[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [projects, setProjects] = useState<ProjectType[]>([]);
  const [interpretationDescription, setInterpretationDescription] =
    React.useState<string[]>([]);
  const [clearSelections, setClearSelections] = useState(false);
  const [chartAnalysis, setChartAnalysis] = useState<any[]>([]);
  const [measurements, setMeasurements] = useState<Option[]>([]);
  const [performanceData, setPerformanceData] = useState<number[]>([]);
  const [medianData, setMedianData] = useState<number[]>([]);
  const [time, setTime] = useState<string[]>([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedMeasurement, setSelectedMeasurement] = useState("");
  const [selectedChart, setSelectedChart] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [charts] = useState<ChartProp[]>(chartdata);
  const [expandChart, setExpandedChart] = useState<ChartProp>(chartdata[0]);
  const [filterCharts, setFilterCharts] = useState<ChartProp[]>(chartdata);
  const [runChartData, setRunChartData] = useState<RunChartDataType[]>([]);
  const [showOtherCharts, setShowOtherCharts] = useState(false);
  const [chartTypes] = useState([
    { label: "Bar Chart", value: "bar" },
    { label: "Line Chart", value: "line" },
    { label: "Pie Chart", value: "pie" },
    { label: "Run Chart", value: "runChart" },
    { label: "Control Chart", value: "controlChart" },
  ]);
  const QITabs = useQualityimprovementTabs();
  const navigate = useNavigate();
  const [showDrawer, setShowDrawer] = useState(false);
  const [showSavedAlert, setShowSavedAlert] = useState(false);
  const [showExpandedRunChart, setShowExpandedRunChart] = useState(false);
  const toast = useToast();

  // states for control chart
  const [lowerLimit, setLowerLimit] = useState<any>(undefined);
  const [upperLimit, setUpperLimit] = useState<any>(undefined);

  useEffect(() => {
    setIsLoading(true);

    const timeoutId = setTimeout(() => {
      setIsLoading(false);
    }, 200);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [selectedProject, selectedMeasurement, selectedChart]);
  const getAndSetDataEntryProjects = async () => {
    const res = await getDataEntryProjects();
    if (res) {
      const rawProjects = res.sort((a, b) => a.id - b.id);
      setProjects(rawProjects);
      const sortedProjects = res
        .sort((a, b) => a.id - b.id)
        .map((project) => {
          return {
            label: project.name,
            value: project.id.toString(),
          };
        });
      console.log("sortedProjects", sortedProjects);

      setAllProjects(sortedProjects);
    }
  };
  useEffect(() => {
    getAndSetDataEntryProjects();
  }, []);
  useEffect(() => {
    setClearSelections(true);
    setTimeout(() => {
      setSelectedMeasurement("");
      setSelectedChart("");
      setFilterCharts(chartdata);
      getAndSetDataEntryProjects();
      setClearSelections(false);
    }, 200);
  }, [selectedProject]);
  const handleDropdownChange = async (value: any, stateVariable: any) => {
    switch (stateVariable) {
      case "selectedProject":
        setSelectedProject(value);
        setSelectedMeasurement("");
        setSelectedChart("");
        setMeasurements(
          projects
            .find((project) => project.id.toString() === value)
            ?.measurements?.map((measurement) => {
              return {
                label: measurement.name,
                value: measurement.id?.toString() || "",
              };
            }) || []
        );
        console.log(
          "selectedProject",
          projects
            .find((project) => project.id.toString() === value)
            ?.measurements?.map((measurement) => {
              return {
                label: measurement.name,
                value: measurement.id?.toString() || "",
              };
            })
        );

        break;
      case "selectedMeasurment":
        setSelectedMeasurement(value);
        console.log("selectedMeasurment", value);

        getMeasurementResults(value).then((res) => {
          console.log("res", res);
          if (res) {
            setData(res);
          } else {
            console.log("Error fetching data");
          }
        });
        break;
      case "selectedChart":
        setSelectedChart(value);
        if (value === "runChart") {
          setUpperLimit(undefined);
          setLowerLimit(undefined);
          setShowOtherCharts(true);
        } else if (value === "controlChart") {
          await getControlChartDate();
          setShowOtherCharts(true);
        } else {
          setShowOtherCharts(false);
        }
        setFilterCharts(charts.filter((chart) => chart.type === value));
        let labels = data.map((data) => data.created_at.split("T")[0]);
        setTime(labels);
        setPerformanceData(
          data.flatMap((dataItem) =>
            dataItem.results.map((resultItem: any) =>
              parseInt(resultItem.result)
            )
          )
        );
        setRunChartData(
          time.map((timePoint, index) => ({
            time: timePoint,
            performance: data[index]?.result,
            Median: medianData[medianData.length - 1],
          }))
        );

        setMedianData(
          data.map((item) => (item.median !== null ? item.median : 20))
        );

        let dataSets: {
          label: string;
          data: number[];
          backgroundColor: string;
        }[] = [
          {
            label: "Performance",
            data: performanceData,
            backgroundColor: "rgba(255, 99, 132, 0.5)",
          },
          {
            label: "Median",
            data: medianData.map((item) => medianData[medianData.length - 1]),
            backgroundColor: "rgba(53, 162, 235, 0.5)",
          },
        ];

        let newChart = charts
          .filter((chart) => chart.type === value)
          .map((chart) => {
            chart.data.datasets = dataSets;
            chart.data.labels = time;
            return chart;
          });

        setFilterCharts(newChart);

        break;
    }
  };

  const getControlChartDate = async () => {
    const data = await getUpperAndLowerLimit(Number(selectedMeasurement));
    setLowerLimit(data?.lcl);
    setUpperLimit(data?.ucl);
  };
  return (
    <Box>
      <Drawer
        size={"full"}
        isOpen={isOpen}
        placement="bottom"
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader
            w={"90%"}
            style={{ textAlign: "left", fontSize: 18 }}
          ></DrawerHeader>

          <DrawerBody px={10} py={10}>
            <Center w={"100%"} h={"100%"}>
              {showExpandedRunChart ? (
                <RunChart
                  data={runChartData}
                  isOnDashboard={false}
                  upperLimit={upperLimit}
                  lowerLimit={lowerLimit}
                  chartInterpretation={chartAnalysis.join(", ")}
                  chartInterpretationDescription={interpretationDescription}
                />
              ) : (
                <AppChart
                  type={expandChart?.type || "bar"}
                  data={expandChart?.data}
                  options={expandChart?.options}
                />
              )}
            </Center>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      {showDrawer && (
        <AppDrawer
          title="Create Chart"
          onClose={() => setShowDrawer(false)}
          size="full"
          placement="bottom"
        >
          <CreateChart
            onDiscard={() => setShowDrawer(false)}
            onSave={() => {
              setShowDrawer(false);

              toast({
                position: "top-right",
                render: () => (
                  <Box color="white" p={3} bg="green">
                    Chart created successfully!
                  </Box>
                ),
              });
            }}
          />{" "}
        </AppDrawer>
      )}
      {showSavedAlert && (
        <Box marginBottom={5}>
          <AppAlertOne
            status="success"
            body="Chart saved successfully!"
            title="Chart"
            onClose={() => setShowSavedAlert(false)}
          />{" "}
        </Box>
      )}
      <Box>
        <Box width={"70%"} margin={"auto"}>
          <Box style={{ gridColumn: "1 / -1" }}>
            <Title
              title={"Quality improvement"}
              onClick={() => {
                navigate("/");
              }}
            />
            <NavigationTabs tabs={QITabs} />
          </Box>

          <HStack
            my={10}
            gap={20}
            justifyContent="space-between"
            display={"flex"}
            flexDirection={"row"}
            alignContent={"center"}
            alignItems={"center"}
            fontWeight={"normal"}
          >
            <FormControl
              style={{
                textAlign: "left",
                fontWeight: "semi-bold",
              }}
            >
              <FormLabel
                display={"flex"}
                mb={0}
                fontWeight={"500"}
                color={color.text}
              >
                Project
                <Text color={"red"} mx={1} fontSize={24}>
                  *
                </Text>
              </FormLabel>

              <Select
                placeholder={selectedProject || "Select Project"}
                options={allProjects}
                onChange={(event: any) =>
                  handleDropdownChange(event?.value, "selectedProject")
                }
              />
              {/* <Text
                marginY={3}
                fontWeight={"normal"}
                color={"red"}
                fontSize={13}
              >
                {selectedProject === "" ? "Project is required" : ""}
              </Text> */}
            </FormControl>
            <FormControl
              style={{
                textAlign: "left",
                fontWeight: "semi-bold",
              }}
            >
              <FormLabel
                display={"flex"}
                mb={0}
                fontWeight={"500"}
                color={color.text}
              >
                Measurement
                <Text color={"red"} mx={1} fontSize={24}>
                  *
                </Text>
              </FormLabel>
              {clearSelections === true ? (
                <></>
              ) : (
                <Select
                  placeholder={
                    selectedMeasurement !== ""
                      ? selectedMeasurement
                      : "Select measurement"
                  }
                  options={measurements}
                  onChange={(event: any) =>
                    handleDropdownChange(event?.value, "selectedMeasurment")
                  }
                />
              )}
            </FormControl>
            <FormControl
              style={{
                textAlign: "left",
                fontWeight: "semi-bold",
              }}
            >
              <FormLabel
                display={"flex"}
                mb={0}
                fontWeight={"500"}
                color={color.text}
              >
                Chart Type
                <Text color={"red"} mx={1} fontSize={24}>
                  *
                </Text>
              </FormLabel>
              {clearSelections === true ? (
                <></>
              ) : (
                <Select
                  placeholder={
                    selectedChart !== "" ? selectedChart : "Select Chart Type"
                  }
                  options={chartTypes}
                  onChange={(event: any) =>
                    handleDropdownChange(event?.value, "selectedChart")
                  }
                />
              )}
            </FormControl>
          </HStack>
          <Box display={"flex"}></Box>

          <AppGrid
            style={{ marginTop: "25px" }}
            columns={{
              base: "repeat(1,1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(2, 1fr)",
              lg: "repeat(2, 1fr)",
            }}
            gap={6}
          >
            <>
              {showOtherCharts && (
                <>
                  {selectedChart === "runChart" || "controlChart" ? (
                    <Box
                      bg={"red"}
                      py={5}
                      width="100%"
                      background={color.teritary}
                      flexDirection={"row"}
                      alignContent={"flex-start"}
                      justifyContent={"flex-end"}
                      alignItems={"flex-start"}
                    >
                      <RunChart
                        data={runChartData}
                        isOnDashboard={true}
                        upperLimit={upperLimit}
                        lowerLimit={lowerLimit}
                        showInterpretation={false}
                      />
                      <Divider />
                      <Button
                        colorScheme="blue"
                        size={"sm"}
                        mt={2}
                        onClick={() => {
                          let analysis = getRunChartInterpretation(
                            data,
                            medianData[medianData.length - 1]
                          );
                          console.log("analysis", analysis);
                          setChartAnalysis(analysis.interpretation);
                          setInterpretationDescription(analysis.description);
                          setShowExpandedRunChart(true);
                          onOpen();
                        }}
                        alignSelf={"flex-end"}
                        w={"20%"}
                        ml={"auto"}
                      >
                        Expand
                      </Button>
                    </Box>
                  ) : (
                    <></>
                  )}
                </>
              )}

              {filterCharts.length !== 0 &&
                filterCharts?.map((chart, index) => (
                  <Box key={index}>
                    {isLoading ? (
                      <AppSkeleton
                        height="300px"
                        width="100%"
                        color={"#d9d9d9"}
                      />
                    ) : (
                      <Box
                        pl={"auto"}
                        bg={"red"}
                        height="400px"
                        width="100%"
                        background={color.teritary}
                        flexDirection={"row"}
                        alignContent={"center"}
                        justifyContent={"flex-end"}
                        alignItems={"center"}
                      >
                        <AppChart
                          type={chart.type}
                          data={chart.data}
                          options={chart.options}
                        />
                        <Button
                          colorScheme="blue"
                          size={"sm"}
                          onClick={() => {
                            setExpandedChart(chart);
                            setShowExpandedRunChart(false);
                            onOpen();
                          }}
                          alignSelf={"flex-end"}
                          w={"20%"}
                          ml={"auto"}
                        >
                          Expand
                        </Button>
                      </Box>
                    )}
                  </Box>
                ))}
            </>
          </AppGrid>
        </Box>
      </Box>
    </Box>
  );
};

export default ChartDashboard;
